import React, { useState } from 'react';
import { Box, Button, Theme } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { createStyles, makeStyles } from '@material-ui/styles';
import { TabletButton } from '@campfire/tablet-button';
import { TooltipMenu } from '../../../common/tooltip-menu';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

export interface CommunicationsOption {
  label: string;
  Icon: React.ElementType;
  disabled?: boolean;
  onClick: () => void;
}

interface CommunicationsOptionsMenuProps {
  options: CommunicationsOption[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {
      color: theme.alert.blue.extraLight,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'none',
      padding: '4px 8px',
      '& span': {
        fontSize: '14px',
      },
      '& svg': {
        fontSize: '16px',
      },
    },
  })
);

/**
 * The Options control used across the app: an outlined button with a chevron, opening a
 * TooltipMenu of icon-led actions. Matches VolunteerCommonProfileActionMenu.
 */
export const CommunicationsOptionsMenu = ({ options }: CommunicationsOptionsMenuProps) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const { theme } = useCampfireTheme();

  return (
    <TooltipMenu
      open={open}
      onClose={() => setOpen(false)}
      title={
        <Box display='flex' flexDirection='column' alignItems='flex-start' style={{ padding: '0 5px' }}>
          {options.map(({ label, Icon, disabled, onClick }) => (
            <Button
              key={label}
              className={classes.item}
              disabled={disabled}
              startIcon={<Icon />}
              onClick={() => {
                setOpen(false);
                onClick();
              }}
            >
              {label}
            </Button>
          ))}
        </Box>
      }
    >
      <TabletButton
        size='small'
        variant='outlined'
        color='primary'
        aria-controls='communications-options-menu'
        aria-haspopup='true'
        onClick={() => setOpen(true)}
        endIcon={<ExpandMore />}
        style={{
          border: '1px solid #9e9e9e',
          boxSizing: 'border-box',
          borderRadius: '4px',
          padding: '5px 10px',
          color: theme.color.grey.neutral300,
        }}
      >
        Options
      </TabletButton>
    </TooltipMenu>
  );
};
